import CarteCadeau from '../../../../assets/lots/badgeRanking/cartecadeau.webp';
import Iphone from '../../../../assets/lots/badgeRanking/iphone.webp';
import AirPods from '../../../../assets/lots/badgeRanking/airpods.webp';
import AirPodsPro from '../../../../assets/lots/badgeRanking/airpodspro.webp';

export default {
  CarteCadeau,
  Iphone,
  AirPods,
  AirPodsPro
};
